import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

import { atomWithParams } from '../../utils/atomWithParams';

import type { Dashboard, TableauFilterState } from './types';

const filtersStorage = createJSONStorage<Record<string, TableauFilterState>>(
  () => sessionStorage,
);
export const filtersAtom = atomWithStorage(
  'jotai-tableau-filters',
  {},
  filtersStorage,
);

export const selectedDashboardAtom = atomWithParams<Dashboard | undefined>(
  'selected-tableau-dashboard',
  undefined,
);

export const detailDrawerOpenAtom = atom(false);
export const detailDashboardUrlAtom = atom('');
export const detailDashParamsAtom = atom<Record<string, string | undefined>>(
  {},
);

const isDevDashboardStorage = createJSONStorage<boolean>(() => sessionStorage);
export const isDevDashboardAtom = atomWithStorage(
  'jotai-is-dev-dashboard',
  false,
  isDevDashboardStorage,
);

export const paramsAtom = atomWithParams<Record<string, any> | undefined>(
  'tableau-parameters',
  undefined,
);

export const tableauSheetAtom = atom<string | undefined>(undefined);
